import { ILoadingCellRendererAngularComp } from '@ag-grid-community/angular';
import { ILoadingCellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

type AgLoadingCell = ILoadingCellRendererParams;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aux-ag-loading-cell',
  standalone: true,
  styles: [],
  template: `
    <div class="spinner m-auto mt-2 h-8 w-8"></div>
  `,
})
export class AgLoadingCellComponent implements ILoadingCellRendererAngularComp {
  params!: AgLoadingCell;

  agInit(params: AgLoadingCell): void {
    this.params = params;
  }
}
